import SectionHeading from "../common/SectionHeading";
import { StaggerGroup, StaggerItem } from "../common/Reveal";
import { Icon } from "../../lib/icon";
import { whyAmvi } from "../../data/site";

export default function WhyAmvi() {
  return (
    <section className="relative px-6 py-24 lg:py-32" data-testid="why-amvi">
      <div className="mx-auto max-w-7xl">
        <SectionHeading
          eyebrow="Why AMVI"
          title="Built for Enterprise. Engineered for Partnership."
          subtitle="A single partner for technology and talent — responsive, specialized and focused on long-term outcomes."
          testId="why"
        />

        <StaggerGroup className="mt-16 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {whyAmvi.map((item) => (
            <StaggerItem key={item.title}>
              <div className="group h-full rounded-2xl border border-white/10 bg-ink-800/40 p-8 transition-all duration-500 hover:-translate-y-1 hover:border-sky-400/40">
                <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-sky-400 transition-colors duration-500 group-hover:text-sky-300">
                  <Icon name={item.icon} className="h-6 w-6" />
                </div>
                <h3 className="font-heading text-lg font-bold tracking-tight text-white">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{item.description}</p>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
